import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class ConsultationPageFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default ConsultationPageFormPresenter;
